import { render } from "./MIcon.vue?vue&type=template&id=304fdd48"
import script from "./MIcon.vue?vue&type=script&lang=ts"
export * from "./MIcon.vue?vue&type=script&lang=ts"
script.render = render

export default script